var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"edit-icon",class:_vm.iconClass,attrs:{"viewBox":"0 0 1024 1024","fill":_vm.color}},[_c('path',{attrs:{"d":"M884 300l-78 78-160-160 78-78q12-12 30-12t30 12l100 100q12 12 12 30t-12 30zM128 736l472-472 160 160-472 472h-160v-160z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }